export default __webpack_public_path__ + "static/media/quarto2.9e5e1ee4.jpeg";